import { render, staticRenderFns } from "./AdminContent.vue?vue&type=template&id=04a5dd3c"
import script from "./AdminContent.vue?vue&type=script&lang=js"
export * from "./AdminContent.vue?vue&type=script&lang=js"
import style0 from "./AdminContent.vue?vue&type=style&index=0&id=04a5dd3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports